import { PROGRAMS } from '../data/programs.js';

// Wire day is zero-based within the rotation; week is one-based. Read the old
// native and local-storage spellings once, then persist only the shared shape.
export function normalizeActiveProgram(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const id = raw.id || raw.programId;
  if (typeof id !== 'string' || !id || id.startsWith('coach:')) return null;
  const startDate = raw.startDate || raw.start;
  if (typeof startDate !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(startDate)) return null;
  const p = PROGRAMS.find(p => p.id === id);
  const day = Number.isInteger(raw.day ?? raw.dayIndex) ? Math.max(0, raw.day ?? raw.dayIndex) : 0;
  return { id, startDate, week: Number.isInteger(raw.week) ? Math.max(1, raw.week) : 1,
    day: p ? day % p.rotation.length : day };
}
export function activeProgramFromWire(data, fallback = null) {
  return Object.hasOwn(data || {}, 'activeProgram') ? normalizeActiveProgram(data.activeProgram) : normalizeActiveProgram(fallback);
}
export function programProgress(active) {
  const a = normalizeActiveProgram(active);
  return a ? `Week ${a.week} · Day ${a.day + 1}` : '';
}
export function builtInSchedule(program) {
  return { weekly: Object.fromEntries(program.types.map((type, i) => [i, type])), overrides: {} };
}
